export default "__VITE_ASSET__29L9ShX$__"